import { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  campaignId: string;
  tenantId?: string | null;
  onSaved?: () => void;
}

export function AdFormDialog({ open, onOpenChange, campaignId, tenantId, onSaved }: Props) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const onSubmit = async () => {
    try {
      setLoading(true);
      const { error } = await supabase.from('calie_ads').insert({
        campaign_id: campaignId,
        tenant_id: tenantId || undefined,
        name,
        status: 'active',
      } as any);
      if (error) throw error;
      toast({ title: 'Ad created' });
      onOpenChange(false);
      setName("");
      onSaved?.();
    } catch (e: any) {
      toast({ title: 'Failed to create ad', description: e.message, variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New Ad</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Input placeholder="Ad name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSubmit} disabled={!name || loading}>Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
